import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 全局状态仓库（Vuex）
// 说明：当前 store 仅维护界面展示用的 userInfo；真正的登录态（token + 用户资料）持久化在 localStorage 的 admin_user 中，由 request.js 拦截器读取并注入请求头
// 结构：state.userInfo 展示信息；mutation SET_USER_INFO / action setUserInfo 用于更新用户信息

export default new Vuex.Store({
  state: {
    // 当前登录用户展示信息：name 姓名、avatar 头像、role 角色（默认值，登录后由 setUserInfo 覆盖）
    userInfo: {
      name: '管理员',
      avatar: '',
      role: 'admin'
    }
  },
  mutations: {
    // 同步更新 userInfo（由 action 提交）
    SET_USER_INFO(state, info) {
      state.userInfo = info
    }
  },
  actions: {
    // 异步 action：提交 SET_USER_INFO，更新用户信息
    setUserInfo({ commit }, info) {
      commit('SET_USER_INFO', info)
    }
  },
  modules: {}
})
